export default __webpack_public_path__ + "static/media/include_10@3x.f213d881.jpg";